import { Autocomplete, Grid, TextField } from '@mui/material';
import { useQuery } from '@parkchirp/api-client';
import React, { useState } from 'react';

import { GET_FACILITY_AREAS_BRANCHES_DISTRICTS_V2 } from '../../queries';
import { FacilityAutocomplete } from '../inputs';

export const RedshiftFacilitySearch = (props) => {
	const {
		selectedAreas,
		setSelectedAreas,
		selectedBranches,
		setSelectedBranches,
		selectedDistricts,
		setSelectedDistricts,
		selectedFacilities,
		setSelectedFacilities,
		handleMultipleFacilityChange,
	} = props;
	const [facilityAreasOptions, setFacilityAreasOptions] = useState<any[]>([]);
	const [facilityDistrictsOptions, setFacilityDistrictsOptions] = useState<any[]>([]);
	const [facilityBranchesOptions, setFacilityBranchesOptions] = useState<any[]>([]);

	const { loading: facilityAreasLoading } = useQuery(GET_FACILITY_AREAS_BRANCHES_DISTRICTS_V2, {
		variables: {
			offset: 0,
			limit: 10,
			order: {
				field: 'facilityName',
				sort: 'asc',
			},
		},
		onCompleted: ({ listFacilityAreasBranchesDistricts: response }) => {
			setFacilityAreasOptions(response.facilityAreas);
			setFacilityBranchesOptions(response.facilityBranches);
			setFacilityDistrictsOptions(response.facilityDistricts);
		},
		context: {
			apiVersion: 'v2',
			appName: process.env.NEXT_PUBLIC_APP_NAME,
		},
	});
	const loading = facilityAreasLoading;
	return (
		<Grid container spacing={2}>
			<Grid item xs={3}>
				<Autocomplete
					id='area-autocomplete'
					disableClearable
					options={facilityAreasOptions}
					value={selectedAreas}
					multiple
					defaultValue={[]}
					getOptionLabel={(option) => option.name ?? ''}
					renderInput={(p) => (
						<TextField
							{...p}
							placeholder='Areas'
							label='Areas'
							inputProps={{
								...p.inputProps,
								'data-cy': 'outstanding-balance-area-autocomplete-dropdown',
							}}
						/>
					)}
					renderTags={() => null}
					onChange={(_, newValue) => {
						setSelectedAreas(newValue);
					}}
					loading={loading}
				/>
				<div style={{ marginTop: 8 }}>
					{selectedAreas.map((area) => (
						<span
							key={area.id}
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								backgroundColor: '#e0e0e0',
								borderRadius: 12,
								padding: '2px 8px',
								marginRight: 4,
								marginBottom: 4,
								fontSize: 12,
							}}
						>
							{area.name}
							<button
								onClick={() => setSelectedAreas((prev) => prev.filter((f) => f.id !== area.id))}
								style={{
									marginLeft: 6,
									background: 'transparent',
									border: 'none',
									cursor: 'pointer',
									fontWeight: 'bold',
									lineHeight: 1,
								}}
								type='button'
							>
								×
							</button>
						</span>
					))}
				</div>
			</Grid>
			<Grid item xs={3}>
				<Autocomplete
					id='branch-autocomplete'
					disableClearable
					options={facilityBranchesOptions}
					multiple
					defaultValue={[]}
					value={selectedBranches}
					getOptionLabel={(option) => option.name ?? ''}
					renderInput={(p) => (
						<TextField
							{...p}
							placeholder='Branches'
							label='Branches'
							inputProps={{
								...p.inputProps,
								'data-cy': 'outstanding-balance-area-autocomplete-dropdown',
							}}
						/>
					)}
					renderTags={() => null}
					onChange={(_, newValue) => {
						setSelectedBranches(newValue);
					}}
					loading={loading}
				/>
				<div style={{ marginTop: 8 }}>
					{selectedBranches.map((branch) => (
						<span
							key={branch.id}
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								backgroundColor: '#e0e0e0',
								borderRadius: 12,
								padding: '2px 8px',
								marginRight: 4,
								marginBottom: 4,
								fontSize: 12,
							}}
						>
							{branch.name}
							<button
								onClick={() => setSelectedBranches((prev) => prev.filter((f) => f.id !== branch.id))}
								style={{
									marginLeft: 6,
									background: 'transparent',
									border: 'none',
									cursor: 'pointer',
									fontWeight: 'bold',
									lineHeight: 1,
								}}
								type='button'
							>
								×
							</button>
						</span>
					))}
				</div>
			</Grid>
			<Grid item xs={3}>
				<Autocomplete
					id='district-autocomplete'
					disableClearable
					options={facilityDistrictsOptions}
					multiple
					defaultValue={[]}
					value={selectedDistricts}
					getOptionLabel={(option) => option.name ?? ''}
					renderInput={(p) => (
						<TextField
							{...p}
							placeholder='Districts'
							label='Districts'
							inputProps={{
								...p.inputProps,
								'data-cy': 'outstanding-balance-area-autocomplete-dropdown',
							}}
						/>
					)}
					renderTags={() => null}
					onChange={(_, newValue) => {
						setSelectedDistricts(newValue);
					}}
					loading={loading}
				/>
				<div style={{ marginTop: 8 }}>
					{selectedDistricts.map((district) => (
						<span
							key={district.id}
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								backgroundColor: '#e0e0e0',
								borderRadius: 12,
								padding: '2px 8px',
								marginRight: 4,
								marginBottom: 4,
								fontSize: 12,
							}}
						>
							{district.name}
							<button
								onClick={() => setSelectedDistricts((prev) => prev.filter((f) => f.id !== district.id))}
								style={{
									marginLeft: 6,
									background: 'transparent',
									border: 'none',
									cursor: 'pointer',
									fontWeight: 'bold',
									lineHeight: 1,
								}}
								type='button'
							>
								×
							</button>
						</span>
					))}
				</div>
			</Grid>
			<Grid item xs={3}>
				<FacilityAutocomplete
					disabled={false}
					onMultipleChange={handleMultipleFacilityChange}
					disableClearable
					allowMultiple
					selectedFacilities={selectedFacilities}
					isForReports
				/>
				<div style={{ marginTop: 8 }}>
					{selectedFacilities.map((facility) => (
						<span
							key={facility.id}
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								backgroundColor: '#e0e0e0',
								borderRadius: 12,
								padding: '2px 8px',
								marginRight: 4,
								marginBottom: 4,
								fontSize: 12,
							}}
						>
							{facility.facilityName}
							<button
								onClick={() =>
									setSelectedFacilities((prev) => prev.filter((f) => f.id !== facility.id))
								}
								style={{
									marginLeft: 6,
									background: 'transparent',
									border: 'none',
									cursor: 'pointer',
									fontWeight: 'bold',
									lineHeight: 1,
								}}
								type='button'
							>
								×
							</button>
						</span>
					))}
				</div>
			</Grid>
		</Grid>
	);
};
